import { render, staticRenderFns } from "./mortgage-total-monthly-payments.vue?vue&type=template&id=0fea537d"
import script from "./mortgage-total-monthly-payments.vue?vue&type=script&lang=js"
export * from "./mortgage-total-monthly-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports